import { EmployeeMetaDataRow } from "../types/Employee";
import { NewConfigSettings } from "../types/ExportExcelEmployee";
import nodeApi from "./nodeApi";
import optionsApi from "./optionsApi";

export async function getExsitingGreytipConfigs() {
  const res = await optionsApi.get("/v1/imports/getExistingConfig/greytip");
  return res.data.data;
}
export async function testHrmsConfig(testBody: any) {
  const res = await optionsApi.post("/v1/imports/testHrmsConfig", testBody);
  return res.data.data;
}
export async function saveConfigCredentials(
  configId: string,
  credentials: any
) {
  const res = await optionsApi.put(`/v1/imports/updateSyncCredentials`, {
    configId,
    credentials,
  });
  return res.data.data;
}
export async function syncHrms(syncConfig: any) {
  const res = await optionsApi.post("/v1/imports/syncHrmsData", syncConfig);
  return res.data.data;
}

export async function saveExportConfig(newConfigObj: NewConfigSettings) {
  const res = await optionsApi.post("/v1/masterApi/save", newConfigObj);
  return res.data.data;
}

export async function updateExportConfig(newConfigObj: NewConfigSettings) {
  const res = await optionsApi.post("/v1/masterApi/edit", newConfigObj);
  return res.data.data;
}

export async function employeeUploadTemplate() {
  const res = await optionsApi.get("/v1/employee/employeeUploadTemplate", {
    responseType: "blob",
  });
  return res.data;
}

export async function validateEmployeeMetaData(file: string) {
  const res = await optionsApi.post(
    "/v1/employee/validateEmployeeMetaDataExcel",
    {
      file,
    }
  );
  return res.data.data;
}

export async function parseEmployeeMetaData(
  file: string
): Promise<EmployeeMetaDataRow[]> {
  const res = await optionsApi.post("/v1/employee/parseEmployeeMetaDataExcel", {
    file,
  });
  return res.data.data;
}

export async function updateEmployeeMetaDataBulk(data: EmployeeMetaDataRow[]) {
  const res = await optionsApi.post("/v1/employee/updateEmployeeMetaDataBulk", {
    data,
  });
  return res.data.data;
}
